export const updateOrInsert = (state, item) => {
  const index = state.items.findIndex(i => i.id && i.id === item.id);
  const query = ['items', index === -1 ? state.items.length : index];
  return state.setIn(query, item);
}

export const updateOrInserAll = (state, items) => {
  items.forEach(i => state = updateOrInsert(state, i));
  return state;
}

export const destroy = (state, id) => {
  return state.updateIn(['items'], items => items.filter(i => i.id !== id));
}



// WEBPACK FOOTER //
// ./src/reducers/helper.js